import {
  FETCH_ROSTER_ATTENDANCE_REQUEST,
  FETCH_ROSTER_ATTENDANCE_SUCCESS,
  FETCH_ROSTER_ATTENDANCE_FAILURE,
  FETCH_ROSTER_ABSENT_DETAILS_REQUEST,
  FETCH_ROSTER_ABSENT_DETAILS_SUCCESS,
  FETCH_ROSTER_ABSENT_DETAILS_FAILURE,
  FETCH_ABSENT_SUMMARY_REQUEST,
  FETCH_ABSENT_SUMMARY_SUCCESS,
  FETCH_ABSENT_SUMMARY_FAILURE,
} from "../constants/RosterAttendanceConstants";

const initialState = {
  loading: false,
  data: [],
  absentDetails: [],
  absentSummary: [],
  error: null,
};

const RosterAttendanceReducer = (state = initialState, action) => {
  switch (action.type) {
    // Roster Attendance cases
    case FETCH_ROSTER_ATTENDANCE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_ROSTER_ATTENDANCE_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };

    case FETCH_ROSTER_ATTENDANCE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Roster Absent Details cases
    case FETCH_ROSTER_ABSENT_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_ROSTER_ABSENT_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        absentDetails: action.payload,
        error: null,
      };

    case FETCH_ROSTER_ABSENT_DETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Absent Summary cases
    case FETCH_ABSENT_SUMMARY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_ABSENT_SUMMARY_SUCCESS:
      return {
        ...state,
        loading: false,
        absentSummary: action.payload,
        error: null,
      };

    case FETCH_ABSENT_SUMMARY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default RosterAttendanceReducer;



// import {
//   FETCH_ROSTER_ATTENDANCE_REQUEST,
//   FETCH_ROSTER_ATTENDANCE_SUCCESS,
//   FETCH_ROSTER_ATTENDANCE_FAILURE,
//   FETCH_ROSTER_ABSENT_DETAILS_REQUEST,
//   FETCH_ROSTER_ABSENT_DETAILS_SUCCESS,
//   FETCH_ROSTER_ABSENT_DETAILS_FAILURE,
// } from "../constants/RosterAttendanceConstants";

// const initialState = {
//   loading: false,
//   data: [],
//   absentDetails: [],
//   error: null,
// };

// const RosterAttendanceReducer = (state = initialState, action) => {
//   switch (action.type) {
//     case FETCH_ROSTER_ATTENDANCE_REQUEST:
//       return {
//         ...state,
//         loading: true,
//         error: null,
//       };

//     case FETCH_ROSTER_ATTENDANCE_SUCCESS:
//       return {
//         ...state,
//         loading: false,
//         data: action.payload,
//         error: null,
//       };

//     case FETCH_ROSTER_ATTENDANCE_FAILURE:
//       return {
//         ...state,
//         loading: false,
//         error: action.payload,
//       };

//     case FETCH_ROSTER_ABSENT_DETAILS_REQUEST:
//       return {
//         ...state,
//         loading: true,
//         error: null,
//       };

//     case FETCH_ROSTER_ABSENT_DETAILS_SUCCESS:
//       return {
//         ...state,
//         loading: false,
//         absentDetails: action.payload,
//         error: null,
//       };

//     case FETCH_ROSTER_ABSENT_DETAILS_FAILURE:
//       return {
//         ...state,
//         loading: false,
//         error: action.payload,
//       };

//     default:
//       return state;
//   }
// };

// export default RosterAttendanceReducer;




// import {
//     FETCH_ROSTER_ATTENDANCE_REQUEST,
//     FETCH_ROSTER_ATTENDANCE_SUCCESS,
//     FETCH_ROSTER_ATTENDANCE_FAILURE,
//     FETCH_ROSTER_ABSENT_DETAILS_REQUEST,
//     FETCH_ROSTER_ABSENT_DETAILS_SUCCESS,
//     FETCH_ROSTER_ABSENT_DETAILS_FAILURE,
// } from "../constants/RosterAttendanceConstants";

// const initialState = {
//     loading: false,
//     data: [],
//     error: null,
// };

// const RosterAttendanceReducer = (state = initialState, action) => {
//     switch (action.type) {
//         case FETCH_ROSTER_ATTENDANCE_REQUEST:
//         case FETCH_ROSTER_ABSENT_DETAILS_REQUEST:
//             return {
//                 ...state,
//                 loading: true,
//                 error: null,
//             };

//         case FETCH_ROSTER_ATTENDANCE_SUCCESS:
//         case FETCH_ROSTER_ABSENT_DETAILS_SUCCESS:
//             return {
//                 ...state,
//                 loading: false,
//                 data: action.payload,
//                 error: null,
//             };

//         case FETCH_ROSTER_ATTENDANCE_FAILURE:
//         case FETCH_ROSTER_ABSENT_DETAILS_FAILURE:
//             return {
//                 ...state,
//                 loading: false,
//                 error: action.payload,
//             };

//         default:
//             return state;
//     }
// };

// export default RosterAttendanceReducer;
